import { SmallRing, BigRing } from '../../assets/ts/pages/landingpage';
import { ReactComponent as SmallRingSVG } from '../../assets/icons/map/ring-1.svg';
import { ReactComponent as BigRingSVG } from '../../assets/icons/map/ring-2.svg';

export function AnimatedRings(props: { children: any }) {
    return (
        <>
            <SmallRing>
                <SmallRingSVG />
            </SmallRing>
            <BigRing>
                <BigRingSVG />
            </BigRing>
            {props.children}
        </>
    );
}